'use client';

import { ForbiddenIllustration } from 'src/assets/illustrations';

import { ErrorPageLayout } from './components/error-page-layout';

// ----------------------------------------------------------------------

/** `/error/403` — 권한 없음 */
export function View403() {
  return (
    <ErrorPageLayout
      title="볼 수 있는 권한이 없습니다"
      description="이 화면은 권한이 있는 분만 볼 수 있습니다. 워크스페이스 관리자에게 권한을 요청해 주세요."
      illustration={<ForbiddenIllustration sx={{ my: { xs: 5, sm: 10 } }} />}
      actionLabel="홈으로 가기"
    />
  );
}
